import React, { useEffect, useState } from 'react';

interface Props {
  deadline: string;
  onExpire?: () => void;
}

const CountdownTimer: React.FC<Props> = ({ deadline, onExpire }) => {
  const calc = () => {
    const diff = new Date(deadline).getTime() - Date.now();
    if (diff <= 0) return null;
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    return { d, h, m, s };
  };

  const [time, setTime] = useState(calc);

  useEffect(() => {
    const id = setInterval(() => {
      const t = calc();
      setTime(t);
      if (!t) { clearInterval(id); onExpire?.(); }
    }, 1000);
    return () => clearInterval(id);
  }, [deadline]);

  if (!time) return <span style={styles.expired}>Deadline passed</span>;

  return (
    <div style={styles.wrap}>
      {time.d > 0 && <><Unit v={time.d} label="d" /><span style={styles.sep}>:</span></>}
      <Unit v={time.h} label="h" />
      <span style={styles.sep}>:</span>
      <Unit v={time.m} label="m" />
      <span style={styles.sep}>:</span>
      <Unit v={time.s} label="s" />
    </div>
  );
};

const Unit: React.FC<{ v: number; label: string }> = ({ v, label }) => (
  <div style={{ textAlign: 'center' }}>
    <div style={{ fontSize: 22, fontWeight: 800, fontVariantNumeric: 'tabular-nums', lineHeight: 1 }}>
      {String(v).padStart(2, '0')}
    </div>
    <div style={{ fontSize: 10, color: '#999', marginTop: 2 }}>{label}</div>
  </div>
);

const styles: Record<string, React.CSSProperties> = {
  wrap: { display: 'flex', alignItems: 'flex-start', gap: 4 },
  sep: { fontSize: 22, fontWeight: 800, lineHeight: '1', color: '#b39ddb', paddingTop: 2 },
  expired: { fontSize: 13, color: '#e53935', fontWeight: 600 },
};

export default CountdownTimer;
